/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {Layout} from "antd";
import React from "react";

import Sider from "./components/sider";
import Header from "./components/header";
import Footer from "./components/footer";
import Drawers from "./drawers/drawer-root";

export default function AppLayout({children}: { children: JSX.Element }) {
    return (
        <Layout style={{height: '100vh'}}>
            <Drawers/>
            <Header/>
            <Layout>
                <Sider/>
                <div className='scrollable' id='main-view'>
                    <Layout.Content>
                        {children}
                    </Layout.Content>
                    <Footer/>
                </div>
            </Layout>
            <a id='downloadAnchor' target='_blank' style={{display: 'none'}} download/>
        </Layout>
    )
}

